import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("div", { class: "px-1 pb-10" }, [
  /*#__PURE__*/_createElementVNode("h1", { class: "leading-6 my-2 font-bold tracking-tight text-gray-900 dark:text-gray-100 text-2xl" }, " Discover images "),
  /*#__PURE__*/_createElementVNode("p", { class: "mt-1 max-w-2xl text-sm text-gray-500 dark:text-gray-400" }, " Browse all the available categories below. ")
], -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_GridFeatured = _resolveComponent("GridFeatured")!
  const _component_TheMainContentFrame = _resolveComponent("TheMainContentFrame")!

  return (_openBlock(), _createBlock(_component_TheMainContentFrame, null, {
    default: _withCtx(() => [
      _hoisted_1,
      _createVNode(_component_GridFeatured, { categories: _ctx.categories }, null, 8, ["categories"])
    ]),
    _: 1
  }))
}